<script lang="ts">
// NOTES + TODOs:
// - the events array in the Editor is not reactive for performance -> see Editor#created()

import { defineComponent } from "vue";
import Video from "../models/Video";
import { Action } from "../models/ActionHierarchy";

export default defineComponent({
  components: {},
  props: {
    videoId: {
      type: Number,
      required: true,
    },
    currentActionId: {
      type: String,
      required: false,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isPlaying: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["jump-to-action-id", "play", "pause"],
  computed: {
    video(): Video | null {
      return Video.query().withAll().find(this.videoId);
    },
    currentAction(): Action | null {
      if (this.currentActionId) return Action.query().withAll().find(this.currentActionId);
      return null;
    },
  },
});
</script>

<template>
  <div v-if="video" class="player-debugger">
    <button :disabled="isPlaying" @click="$emit('play')">Play</button>
    <button :disabled="!isPlaying" @click="$emit('pause')">Pause</button>
    <ol start="0">
      <li
        v-for="action in video.actions"
        :key="action.id"
        :style="currentActionId === action.id ? { backgroundColor: '#666' } : {}"
      >
        <button @click="$emit('jump-to-action-id', action.id)">Jump</button>
        <strong>&lt;{{ action.type }}&gt;</strong>: {{ action.id }}, {{ action.timings.total }} sec
        <div v-if="action.voiceOver">voiceOver: {{ action.voiceOver }}</div>
      </li>
    </ol>
    <pre>
current voiceOver audio: {{
        currentAction && currentAction.voiceOver && currentAction.voiceOver.selectedAudioRecording
      }}
    </pre>
  </div>
</template>
